import styled from 'styled-components';

export const Text = styled.span`
	margin-bottom: 20px;
	display: block;
	direction: rtl;
`;
